import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "@/components/PolicyPage";

export const Route = createFileRoute("/policies/refund-policy")({
  head: () => ({
    meta: [
      { title: "Return & Refund — Coyote Creek Hat Co." },
      { name: "description", content: "Our return, exchange, and refund policy for Coyote Creek Hat Co. hats and apparel, including timelines, condition rules, and how to start a return." },
      { property: "og:title", content: "Return & Refund — Coyote Creek Hat Co." },
      { property: "og:description", content: "Our return, exchange, and refund policy for Coyote Creek Hat Co. hats and apparel, including timelines, condition rules, and how to start a return." },
      { property: "og:url", content: "https://coyotecreekhatco.com/policies/refund-policy" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/policies/refund-policy" }],
  }),
  component: () => <PolicyPage policyKey="refundPolicy" fallbackTitle="Return & Refund" />,
});
